import {createSvgIcon} from '../create-svg-icon';

export const NavigateNextIcon = createSvgIcon(
  <path d="M10.02 6 8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z" />
, 'NavigateNextOutlined');
